// extracted by mini-css-extract-plugin
export default {"h":"styles_h__j4GmM","p":"styles_p__O5FTi","box":"styles_box__JkPPY"};